import { render, staticRenderFns } from "./place_order.vue?vue&type=template&id=e40f5f20&scoped=true"
import script from "./place_order.vue?vue&type=script&lang=js"
export * from "./place_order.vue?vue&type=script&lang=js"
import style0 from "./place_order.vue?vue&type=style&index=0&id=e40f5f20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e40f5f20",
  null
  
)

export default component.exports